import { DialogContent, DialogTitle, Grid } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import { TransitionProps } from "@material-ui/core/transitions";
import CloseIcon from "@material-ui/icons/Close";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";

interface AppDialogFullScreenProps {
  onCancel: () => void;
  titleClass?: string;
  open: boolean;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
}

const useStyles = makeStyles(
  theme => ({
    title: {
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
        padding: 0
      },
      background:
        "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
      fontWeight: 700,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    },
    closeIcon: {
      border: "none"
    },
    containerPad: {
      padding: "0px 64px 40px !important"
    },
    titlePad: {
      padding: "40px 64px 16px !important"
    }
  }),
  { name: "AppDialogFullScreen" }
);

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const AppDialogFullScreen: React.FC<AppDialogFullScreenProps> = ({
  onCancel,
  open,
  title,
  titleClass,
  content
}) => {
  const classes = useStyles({});

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={onCancel}
        TransitionComponent={Transition}
      >
        <DialogTitle className={classes.titlePad}>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <MyTypography
                variant="h6"
                className={classNames(classes.title, titleClass)}
              >
                {title}
              </MyTypography>
            </Grid>
            <Grid item>
              <Grid container alignItems="center" spacing={1}>
                <MyTypography variant="body3">ปิดหน้าต่าง</MyTypography>
                <IconButton
                  id="closeButton"
                  edge="end"
                  color="inherit"
                  onClick={onCancel}
                  aria-label="close"
                  className={classes.closeIcon}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className={classes.containerPad}>
          {content}
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default AppDialogFullScreen;
